import { getLocale } from "../runtime";

const da_whathappensnow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hvad sker der nu?`
};

const en_whathappensnow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `What happens now?`
};

const es_whathappensnow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `¿Qué pasa ahora?`
};

const fi_whathappensnow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Mitä nyt tapahtuu?`
};

const nb_whathappensnow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hva skjer nå?`
};

const sv_whathappensnow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vad händer nu?`
};

const whathappensnow = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_whathappensnow(inputs)
	if (locale === "en") return en_whathappensnow(inputs)
	if (locale === "es") return es_whathappensnow(inputs)
	if (locale === "fi") return fi_whathappensnow(inputs)
	if (locale === "nb") return nb_whathappensnow(inputs)
	if (locale === "sv") return sv_whathappensnow(inputs)
	return "whatHappensNow";
};

export { whathappensnow as "whatHappensNow" };